import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./SettingModal.css";
import { InputSwitch } from "primereact/inputswitch";
import { cookieService } from "../services/CookieService";
import { RadioButton } from 'primereact/radiobutton';
import { SettingsCookieModal } from "../components/NavigationBar/Models/SettingCookieModel";
import { utils } from '../utils';
import { Ripple } from "primereact/ripple";
import EventEmitter, { Events } from "../services/eventemitter";

import { t } from "i18next";
import { LoginResponse } from "../models";
import { DetectEnvironment } from "../EnvironmentSettings";

interface SettingsModalState {
    chatNotificationsChecked: boolean;
    unsentChatNotificationsChecked: boolean;
    soundAlertsChecked: boolean;
    selectedTemplate: any,
    selectedLanguageTemplate: any,
    linkPreview: boolean;
}

interface SettingsModalProps {
    onHide: () => void;
    isChatScreenActive: boolean
}

export default class SettingsModal extends Component<SettingsModalProps, SettingsModalState> {
    Templates: any = []
    LanguageTemplates: any = []
    userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

    constructor(props) {
        super(props);

        var settingCookies = cookieService.getSettingsCookies();


        this.state = {
            chatNotificationsChecked: settingCookies?.chatNotifications ?? false,
            unsentChatNotificationsChecked: settingCookies?.unsentChatNotifications ?? true,
            soundAlertsChecked: settingCookies?.soundAlerts ?? true,
            selectedTemplate: 1,
            selectedLanguageTemplate: "en",
            linkPreview: settingCookies?.linkPreview ?? true,
        };

        this.Templates = [
            { title: 'Template 1', key: 0 },
            { title: 'Template 2', key: 1 },
            { title: 'Template 3', key: 2 },
            { title: 'Template 4', key: 3 },
        ];
        this.LanguageTemplates = [
            { title: 'English', key: "en" },
            { title: 'Arabic', key: "ar" },
            { title: 'Chinese', key: "ch" }
        ];
    }

    componentDidMount() {
        const language = utils.isArabicLanguage() ? "ar" : utils.isChineseLanguage() ? "ch" : "en"
        // this.setState({ selectedLanguageTemplate: language })
        var selectedlanguage = cookieService.getElectronCookies('language')
        if (selectedlanguage) {
            this.setState({ selectedLanguageTemplate: selectedlanguage })
        } else {
            this.setState({ selectedLanguageTemplate: language })
        }
        if (!utils.isThisMobileDevice()) {
            if (this.props.isChatScreenActive) {
                var res = cookieService.getSettingsCookies();
                if (res == null) {
                    this.setState({ selectedTemplate: this.Templates[1]?.key })
                }
                else {
                    let value = this.Templates?.find(x => x.key == res?.selectedTemplate)
                    this.setState({ selectedTemplate: value?.key })
                }
            }
        }
    }


    onHide = () => {
        this.manageCookies(null)
        this.props.onHide();
    };

    handleSelectTemplate = (e) => {
        this.setState({ selectedTemplate: e.value.key })
        this.manageCookies(e.value.key)

        EventEmitter.emit(Events.handleLayout, e.value.key)
        // window.location.reload();
    }
    handleSelectLanguageTemplate = (e) => {
        this.setState({ selectedLanguageTemplate: e.value.key })
        cookieService.setElectronCookies('language', e.value.key);
        EventEmitter.emit(Events.setWebContentLang, e.value.key)
        if (utils.isElectronBuild()) {
            let obj = { userId: this.userData?.userLoginData?.userId, selectedLanguage: e.value.key }
            window.myAPI.PersistLanguage(obj)
        }
        // window.location.reload();
    }

    manageCookies = (template) => {
        var settingCookies: SettingsCookieModal = {} as any;
        var res = cookieService.getSettingsCookies();
        if (res != null) {
            res.chatNotifications = this.state.chatNotificationsChecked;
            res.soundAlerts = this.state.soundAlertsChecked;
            res.linkPreview = this.state.linkPreview;
            res.unsentChatNotifications = this.state.unsentChatNotificationsChecked;
            res.selectedTemplate = template == null ? this.state.selectedTemplate : template;
            cookieService.setSettingsCookies(res);
        }
        else {
            settingCookies.chatNotifications = this.state.chatNotificationsChecked;
            settingCookies.soundAlerts = this.state.soundAlertsChecked;
            settingCookies.linkPreview = this.state.linkPreview;
            settingCookies.unsentChatNotifications = this.state.unsentChatNotificationsChecked;
            settingCookies.selectedTemplate = template == null ? this.state.selectedTemplate : template;
            cookieService.setSettingsCookies(settingCookies);
        }
    }

    render(): React.ReactNode {
        return (
            <Modal isOpen={true} toggle={this.onHide} className="setting-modal">
                <ModalHeader>{utils.isElectronBuild() == true ? t('settingsModal.Settings') : t('settingsModal.Settings (Cookie Based )')}
                    <button
                        type="button"
                        onClick={this.onHide}
                        data-dismiss="modal"
                        aria-label="Close"
                        className="close p-ripple"
                    >
                        <Ripple /> <span aria-hidden="true">&times;</span>
                    </button>

                </ModalHeader>
                <ModalBody>
                    <div className="form-group switch-btn ">
                        <h2>{t('settingsModal.Chat')}</h2>
                        <InputSwitch
                            checked={this.state.chatNotificationsChecked}
                            onChange={(e) => this.setState({ chatNotificationsChecked: e.value })}
                        />
                    </div>
                    <div className="form-group switch-btn ">
                        <h2>{t('settingsModal.UnsentChat')}</h2>
                        <InputSwitch
                            checked={this.state.unsentChatNotificationsChecked}
                            onChange={(e) => this.setState({ unsentChatNotificationsChecked: e.value })}
                            trueValue={true}
                            falseValue={false}
                        />
                    </div>
                    <div className="form-group switch-btn ">
                        <h2>{t('settingsModal.Sound Alerts')}</h2>
                        <InputSwitch checked={this.state.soundAlertsChecked} onChange={(e) => this.setState({ soundAlertsChecked: e.value })} />
                    </div>

                    <div className="form-group switch-btn ">
                        <h2>{t('settingsModal.Link Preview')}</h2>
                        <InputSwitch checked={this.state.linkPreview} onChange={(e) => this.setState({ linkPreview: e.value })} />
                    </div>

                    {this.props.isChatScreenActive && !utils.isThisMobileDevice() ? (
                        <div className="form-group switch-btn ">
                            <h2>{t('settingsModal.Heading')}</h2>
                            <div className="templates">
                                {
                                    this.Templates?.map((ele) => {
                                        return (
                                            <div key={ele.key} className="field-radiobutton">
                                                <RadioButton inputId={ele.key} name="ele" value={ele}
                                                    onChange={(e) => this.handleSelectTemplate(e)}
                                                    checked={this.state.selectedTemplate === ele.key} />
                                                <label htmlFor={ele.key}>{ele.title}</label>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    ) : ("")}

                    {DetectEnvironment.config.REACT_APP_IS_LOCALIZATION_ENABLE &&
                        <><div className="form-group switch-btn ">
                            <h2>{t('resourcesPoolTable.Language')}</h2>
                        </div>

                            <div className="templates">
                                {
                                    this.LanguageTemplates?.map((ele) => {
                                        return (
                                            <div key={ele.key} className="field-radiobutton">
                                                <RadioButton inputId={ele.key} name="ele" value={ele}
                                                    onChange={(e) => this.handleSelectLanguageTemplate(e)}
                                                    checked={this.state.selectedLanguageTemplate === ele.key} />
                                                <label htmlFor={ele.key}>{ele.title}</label>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </>}
                </ModalBody>
            </Modal>
        );
    }
}
